export default __webpack_public_path__ + "static/media/01.5fa6455a.jpg";